export default "__VITE_ASSET__Bdx_$Feb__"